import { LoaderFunctionArgs } from 'react-router-dom';
import { VERSION_DATA_QUERY_CONTEXT } from '../../components/TeachingBlockVersion/hooks/useTeachingBlockVersionData';
import {
  _SubjectContainersDocument,
  _SubjectContainersQuery,
  _SubjectContainersQueryVariables,
  TeachingBlockVersionDataDocument,
  TeachingBlockVersionDataQuery,
  TeachingBlockVersionDataQueryVariables,
} from '../../types/planung-graphql-client-defs';
import { addLeadingZero } from '../helper';
import { urqlClient } from '../urqlClient';

export async function teachingBlockVersionLoader(
  args: LoaderFunctionArgs<{ teachingBlockVersionUuid: string }>,
): Promise<{ subjectContainerName: string; versionName: string; versionUuid: string }> {
  const uuid = args.params.teachingBlockVersionUuid;

  // Beide Abfragen laufen parallel; das Lesemodell der Version ist dasselbe, das danach das Board lädt.
  const [{ data }, { data: subjectContainersData }] = await Promise.all([
    urqlClient
      .query<TeachingBlockVersionDataQuery, TeachingBlockVersionDataQueryVariables>(
        TeachingBlockVersionDataDocument,
        { versionUuid: uuid ?? '' },
        VERSION_DATA_QUERY_CONTEXT,
      )
      .toPromise(),
    urqlClient
      .query<_SubjectContainersQuery, _SubjectContainersQueryVariables>(_SubjectContainersDocument, {})
      .toPromise(),
  ]);

  const meta = data?.teachingBlockVersionData?.meta;

  return {
    versionUuid: meta?.versionUuid ?? '',
    subjectContainerName:
      subjectContainersData?.subjectContainers.find((sc) => sc.uuid === meta?.subjectContainerUuid)?.name ?? '',
    versionName: `v${addLeadingZero(meta?.version ?? 0)}`,
  };
}
